export const sendSms = async ({ to, message }) => {
    const clientId = process.env.REACT_APP_HUBTEL_CLIENT_ID;
    const clientSecret = process.env.REACT_APP_HUBTEL_CLIENT_SECRET;
    const from = process.env.REACT_APP_HUBTEL_SENDER_ID;
  
    const baseUrl = 'https://smsc.hubtel.com/v1/messages/send';
  
    const url = `${baseUrl}?clientid=${clientId}&clientsecret=${clientSecret}&from=${from}&to=${to}&content=${encodeURIComponent(message)}`;
  
    try {
      const res = await fetch(url);
      const data = await res.json();
      console.log("📲 SMS response:", data);
      return data;
    } catch (err) {
      console.error("❌ SMS sending failed:", err);
      return null;
    }
  };
  